import { useState } from "react";
import {
  Box, Card, CardContent, TextField, Button,
  Typography, InputAdornment, Alert, CircularProgress
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SchoolIcon from "@mui/icons-material/School";
import api from "../api/api";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const login = async () => {
    if (!username || !password) {
      setError("Enter your username and password.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const form = new URLSearchParams();
      form.append("username", username);
      form.append("password", password);
      const res = await api.post("/auth/login", form);
      localStorage.setItem("token", res.data.access_token);
      window.location.href = "/dashboard";
    } catch {
      setError("Incorrect username or password.");
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => { if (e.key === "Enter") login(); };

  return (
    <Box sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #1a1a1a 0%, #3d0000 50%, #C62828 100%)",
    }}>
      <Card sx={{ width: 400, borderRadius: 3, overflow: "hidden", boxShadow: 10 }}>

        {/* Red header */}
        <Box sx={{
          background: "linear-gradient(135deg, #C62828, #8B0000)",
          py: 4, px: 3,
          display: "flex", flexDirection: "column", alignItems: "center", gap: 1,
        }}>
          <Box sx={{
            bgcolor: "rgba(255,255,255,0.15)",
            borderRadius: "50%", p: 1.5, mb: 0.5,
          }}>
            <SchoolIcon sx={{ fontSize: 40, color: "white" }} />
          </Box>
          <Typography variant="h5" sx={{ color: "white", fontWeight: 700, textAlign: "center" }}>
            Training Management System
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)", textAlign: "center" }}>
            Welcome — enter your credentials to continue
          </Typography>
        </Box>

        {/* Form */}
        <CardContent sx={{ px: 4, py: 3 }}>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
              {error}
            </Alert>
          )}

          <TextField
            fullWidth
            label="Username"
            autoComplete="username"
            sx={{ mb: 2 }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKey}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonOutlineIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            label="Password"
            type="password"
            autoComplete="current-password"
            sx={{ mb: 3 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKey}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlinedIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={login}
            disabled={loading}
            sx={{ py: 1.4, fontWeight: 600, fontSize: "1rem", borderRadius: 2 }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Log in"}
          </Button>

        </CardContent>
      </Card>
    </Box>
  );
}
